import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Produkte from "./pages/Produkte";
import Anfrage from "./pages/Anfrage";
import Login from "./pages/Login";
import LegalPage from "./pages/LegalPage";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function AppContent() {
  const location = useLocation();
  // Auth-Callback zuerst verarbeiten (session_id im URL-Fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cosplay" element={<Anfrage type="cosplay" />} />
          <Route path="/3d-druck" element={<Anfrage type="druck" />} />
          <Route path="/produkte" element={<Produkte />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profil" element={<Profile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/impressum" element={<LegalPage type="impressum" />} />
          <Route path="/agb" element={<LegalPage type="agb" />} />
          <Route path="/datenschutz" element={<LegalPage type="datenschutz" />} />
          <Route path="/widerruf" element={<LegalPage type="widerruf" />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </div>
      <Footer />
      <CartDrawer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
